import React from 'react';
import Checkbox, { CheckboxProps } from './Checkbox';
import { classNames } from './classNames';

export interface SwitchProps extends CheckboxProps {
  switchClassName?: string;
}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(({
  wrapperClassName,
  switchClassName,
  ...props
}, ref) => (
  <Checkbox
    ref={ref}
    wrapperClassName={classNames('form-switch', switchClassName, wrapperClassName)}
    {...props}
  />
));

Switch.displayName = 'Switch';

export default Switch;

